import {IO as module} from '../actions/index';
const {actiontypes} = module;


const initialState = {
  messages: [],
  loading: false,
}

export default function io(state = initialState, action) {

  switch(action.type) {
    case actiontypes.MESSAGE:
      let message = {
        key: new Date().getTime(),
        text: action.message,
        variant: action.variant
      }
      return {...state,
        loading: action.loading === null ? state.loading : action.loading,
        messages: [...state.messages, message]
      };
    case actiontypes.LOADING:
      return {...state,
        loading: action.loading,
      };
    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/io.js